module.exports = __webpack_public_path__ + "static/media/seta_direita.096902d1.svg";